import { Switch } from 'components/atoms/switch/switch';
import { Tag } from 'components/atoms/tag';
import { getRandomColor } from 'utils/get-random-color';

export const ReasonCodeRenderer = ({ data }) => {
  return (
    <Tag color={getRandomColor(data.reasonId)} key={data.reasonId}>
      {data.reason}
    </Tag>
  );
};

export const StatusRenderer = ({
  data,
  onUpdateStatus,
}: {
  data: { reasonId: number; active: boolean };
  onUpdateStatus: (reasonId: number, active: boolean) => void;
}) => {
  return (
    <Switch
      size="small"
      checked={data.active}
      onChange={(checked) => onUpdateStatus(data.reasonId, checked)}
    />
  );
};
